"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinListeners = exports.spin = exports.setSpinner = exports.getSpinner = void 0;
const isInteractive = require("is-interactive");
const k = require("kleur");
let frame = isInteractive() ? 0 : -1;
let spinning;
let spinCount = 0;
let spinner = {
    interval: 80,
    frames: ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'],
    color: k.cyan,
};
/** Get the current spinner string */
function getSpinner() {
    return spinner.color(frame < 0 ? '∞' : spinner.frames[frame]);
}
exports.getSpinner = getSpinner;
/** Customize the spinner used for active tasks */
function setSpinner(config) {
    spinner = config;
}
exports.setSpinner = setSpinner;
/** Enable or disable the spin interval */
function spin(enabled) {
    if (frame < 0)
        return;
    if (enabled) {
        if (++spinCount > 1)
            return;
        spinning = setInterval(() => {
            if (++frame == spinner.frames.length)
                frame = 0;
            exports.spinListeners.forEach(onSpin => onSpin());
        }, spinner.interval);
    }
    else if (spinCount > 0) {
        if (--spinCount > 0)
            return;
        clearInterval(spinning);
    }
}
exports.spin = spin;
/** These functions are called when the spinner updates */
exports.spinListeners = new Set();
//# sourceMappingURL=spin.js.map